import React, { ChangeEvent, PropsWithChildren, useCallback } from 'react';
import { TablePagination } from '@material-ui/core';
import { TableInstance } from 'react-table';

// eslint-disable-next-line @typescript-eslint/ban-types
const Pagination = <T extends {}>({
  instance,
}: PropsWithChildren<{ instance: TableInstance<T> }>) => {
  const {
    state: { pageIndex, pageSize, rowCount = instance.rows.length },
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
  } = instance;

  const handleChangePage = useCallback(
    (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
      newPage: number,
    ) => {
      if (newPage === pageIndex + 1) {
        nextPage();
      } else if (newPage === pageIndex - 1) {
        previousPage();
      } else {
        gotoPage(newPage);
      }
    },
    [gotoPage, nextPage, pageIndex, previousPage],
  );

  const onChangeRowsPerPage = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setPageSize(Number(event.target.value));
    },
    [setPageSize],
  );

  return rowCount ? (
    <TablePagination
      rowsPerPageOptions={[5, 10, 25, 50]}
      component="div"
      count={rowCount}
      rowsPerPage={pageSize}
      page={pageIndex}
      onPageChange={handleChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      labelRowsPerPage="表示件数"
      labelDisplayedRows={({ from, to, count }) => {
        return `全${count}件中${from}〜${to}件を表示`;
      }}
    />
  ) : null;
};

export default Pagination;
